import React from "react";
import { motion } from "framer-motion";
import { Tag } from "antd";
import type { ModuleConfig } from "../config/modules";

const itemVariants = {
  hidden: { y: 16, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring" as const, stiffness: 110 },
  },
};

interface Props {
  module: ModuleConfig;
}

const ModuleCard: React.FC<Props> = ({ module }) => {
  const isActive = module.status === "active";
  const Icon = module.icon;

  const onClick = () => {
    if (!isActive) return;
    // Same-origin navigation — works once the module is mounted under its path
    // on the unified domain.
    window.location.href = module.path;
  };

  return (
    <motion.div
      variants={itemVariants}
      whileHover={
        isActive
          ? { y: -4, boxShadow: "0 10px 24px rgba(0,0,0,0.08)" }
          : undefined
      }
      whileTap={isActive ? { scale: 0.98 } : undefined}
      onClick={onClick}
      style={{
        cursor: isActive ? "pointer" : "not-allowed",
        background: "#fff",
        borderRadius: 12,
        padding: 20,
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        opacity: isActive ? 1 : 0.6,
        transition: "box-shadow .2s ease",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          marginBottom: 12,
        }}
      >
        <div
          style={{
            width: 52,
            height: 52,
            minWidth: 52,
            borderRadius: 12,
            background: module.bgGradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon style={{ fontSize: 26, color: module.iconColor }} />
        </div>
        <div
          style={{
            fontSize: 16,
            fontWeight: 600,
            color: "#1e293b",
            flex: 1,
          }}
        >
          {module.name}
        </div>
        {!isActive && (
          <Tag color="warning" style={{ marginRight: 0 }}>
            Coming soon
          </Tag>
        )}
      </div>
      <p
        style={{
          margin: 0,
          color: "#64748b",
          fontSize: 13,
          lineHeight: 1.5,
        }}
      >
        {module.description}
      </p>
    </motion.div>
  );
};

export default ModuleCard;
